  document.addEventListener('DOMContentLoaded', function () {
    const deliveryMessages = document.querySelectorAll('.delivery-message');
    const variantSelector = document.querySelector('[name="id"]'); // El selector de variantes

    function updateDeliveryMessage(variantId) {
      deliveryMessages.forEach(function (msg) {
        msg.style.display = msg.dataset.variantId === variantId ? 'block' : 'none';
      });
    }

    if (variantSelector) {
      // Al cargar la página con la primera variante seleccionada
      updateDeliveryMessage(variantSelector.value);

      // Cuando cambia la variante seleccionada
      variantSelector.addEventListener('change', function () {
        updateDeliveryMessage(this.value);
      });
    }
  });